var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d09861;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "restaurants_and_cafe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_pin_fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.33,4.91A14.6,14.6,0,0,0,4.67,25.56S15,35.68,15,47.37c0-11.68,10.33-21.8,10.33-21.8A14.6,14.6,0,0,0,25.33,4.91Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.72,6.39v4.72h-.85V6.42a.43.43,0,1,0-.85,0v4.69h-.85V6.41a.43.43,0,0,0-.85,0v4.72H9.46V6.43a.43.43,0,0,0-.85,0v6.17A1.61,1.61,0,0,0,10.31,14V25.18a1.28,1.28,0,1,0,2.56,0V14a1.71,1.71,0,0,0,1.71-1.38V6.41A.43.43,0,0,0,13.72,6.39ZM17.56,7.7V18.36h.85v6.82c0,1.71,3,1.71,3,0V7.7C21.39,5.57,17.56,5.57,17.56,7.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/restaurants.1f43e71f92be1da8e266fa73e4b705e6.svg";
export { ForwardRef as ReactComponent };